import { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Box, Button, Divider, Grid, Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles';

import PinDropIcon from '@mui/icons-material/PinDrop';
import { AppContainer } from '@shared/components/AppContainer';
import CategoriesList from '../components/Categories';
import TokenCard from '@shared/components/TokenCard';
import { IToken } from '@interfaces/token';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { SocialIcons } from '../components/SocialIcons';
import { AppNoToken } from '@shared/components/AppNoToken';
import { deepClone, isBusiness } from '@shared/helpers/global.helper';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { businessService } from '@services/business.service';
import { Category } from '@interfaces/caetgory';
import { Business } from '@interfaces/register';
import { CategorySkeleton } from '@shared/skeletons/CategorySkeleton';
import LogoPlaceholder from '@assets/images/BusinessLogoPlaceholder.svg'
import CoverPlaceholder from '@assets/images/BusinessTitlePlaceholder.svg'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        '&$selected': {
            backgroundColor: `${theme.palette.primary.dark} !important`,
            color: 'white !important',
            '& button': {
                color: 'white !important',
            }
        },
    },
    selected: {},
    cover: {
        width: '100%',
        maxHeight: '320px',
        objectFit: 'cover'
    },
    controls: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        position: 'relative',
        minHeight: '50px'
    },
    businessDescriptionContainer: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column'
        }
    },
    contactButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
            marginTop: '40px'
        },
        width: '100%'
    },
    title2: {
        fontSize: '24px !important',
        lineHeight: '28px important',
        fontStyle: 'normal',
        color: '#1E293B !important'
    },
    contactButton: {
        width: '255px',
        height: '56px',
        padding: '16px 24px 16px 24px !important',
        borderRadius: '8px !important',
        textAlign: 'center'
    },
    contactButtonText: {
        fontStyle: 'normal',
        fontSize: '14px !important',
        lineHeight: '16px !important',
        letterSpacing: '0.05em !important'
    },
    businessHeadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justify: 'flex-start',
        marginBottom: '24px'
    },
    businessPic: {
        height: '160px',
        width: '160px',
        borderRadius: '50%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        objectFit: 'cover'
    },
    location: {
        padding: '0px 8px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '12px',
        color: '#009F4D',
        backgroundColor: 'rgba(0, 159, 77, 0.1);',
        borderRadius: '34px',
        textTransform: 'uppercase'
    },
    locationText: {
        fontStyle: 'normal',
        fontSize: '12px !important',
        lineHeight: '14px !important',
        letterSpacing: '0.03em',
        color: '#009F4D',
        textAlign: 'center',
        marginLeft: '12.66px !important'
    },
    description: {
        fontStyle: 'normal',
        fontSize: '14px !important',
        lineHeight: '18px !important',
        letterSpacing: '0.0168em !important',
        color: '#475569',
        textAlign: 'left'
    },
    reviews: {
        fontSize: '14px',
        fontWeight: 400,
        color: '#475569',
        marginTop: '26px'
    },
    sales: {
        marginRight: '10px'
    },
    starIcon: {
        height: '20px',
        marginRight: '12px'
    },

    gridContainer: {
        marginBottom: '24px'
    },
    ratings: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '35px'
    },
    col1: {
        width: '100%',
        maxWidth: '350px',
        marginRight: '30px'
    },
    col2: {
        width: '100%'
    },
}));


export const BusinessPage = () => {
    const classes = useStyles();
    const [selectedCategory, setSelectedCategory] = useState('all')
    const [categories, setCategories] = useState<Array<Category>>([])
    const [business, setBusiness] = useState<Business>({} as Business)
    let { id } = useParams<{ id: string }>();
    let history = useHistory();

    const onCategorySelect = (id: string) => {
        setSelectedCategory(id)
    }

    const onTokenSelect = (id: number) => {
        // history.push(`/tokens/${id}`)
        history.push(`/public/token/${id}`)
    }

    const getCategoryName = () => {
        if (selectedCategory === 'all') return 'All';
        const category = categories.find((c: any) => c.id === selectedCategory);
        return category?.name;

    }

    const getCategories = async (businessData: Business) => {
        const response: any = await businessService.getCategories();
        const categoryClone = deepClone(response.data?.data)
        categoryClone?.forEach((category: any) => {
            const tokens = businessData?.tokens?.filter((item: IToken) => {
                return item.profile?.category.id === category?.id;
            })
            category.count = tokens?.length;
        })
        setCategories(categoryClone)
        setSelectedCategory('all')
    }


    const getBusiness = async (id: string) => {
        const response: any = await businessService.getBusinessById(id);
        let business = response.data?.data;
        business.tokens = business.tokens.map((token: any) => {
            return {
                ...token,
                business: {
                    owner: business?.owner,
                    state: business?.state,
                    name: business?.name,
                    location: business?.location,
                    city: business?.city,
                }
            }
        })
        setBusiness(business)
        getCategories(response.data?.data);
    }

    useEffect(() => {
        if (id) {
            getBusiness(id)
        }
    }, [id])

    let filteredTokens = [];

    if (selectedCategory == 'all') {
        filteredTokens = business?.tokens;
    } else {
        const tokens = business?.tokens.filter(item => {
            return item.profile?.category.id === selectedCategory;
        })
        filteredTokens = tokens
    }

    return (
        <>
            <img src={business?.cover?.file || CoverPlaceholder} className={classes.cover} />
            <AppContainer>
                <Box className={classes.controls}>
                    <img src={business?.logo?.file || LogoPlaceholder} className={classes.businessPic} alt='Business Logo' />
                    {isBusiness() && (
                        <label htmlFor="icon-button-edit">
                            <IconButton color="primary" aria-label="edit profile" component={Link} to={`/settings`} >
                                <EditIcon />
                            </IconButton>
                        </label>

                    )}
                </Box>
                <Box mt={6}>
                    <Box className={classes.businessHeadingContainer}>
                        <Typography className={'title2'}>{business?.name} </Typography>
                        <Box className={classes.location} ml={3}>
                            <PinDropIcon fontSize='small' />
                            <Typography className={`${classes.locationText}`}>{business?.owner?.city}</Typography>
                        </Box>
                        <Box className={classes.location} ml={3}>
                            <PinDropIcon fontSize='small' />
                            <Typography className={`${classes.locationText}`}>{business?.owner?.state}</Typography>
                        </Box>
                    </Box>
                    <Box className={`${classes.businessDescriptionContainer}`}>
                        <Box width={'100%'} maxWidth={730}>
                            <Typography className={`${classes.description} wrapword`} fontWeight={500}>{business?.description}</Typography>
                        </Box>
                        {/* <Box className={`${classes.contactButtonContainer}`}>
                            <Button variant='contained' startIcon={<SendIcon />} className={`${classes.contactButton}`}>
                                <Typography fontWeight={700} className={`${classes.contactButtonText}`}>Contact</Typography>
                            </Button>
                        </Box> */}
                    </Box>
                </Box>
                <Box>
                    <SocialIcons profile={business} />
                </Box>
                <Box my={6}>
                    <Divider />
                </Box>
                <Grid container spacing={8}>
                    <Grid item md={3} xs={12} >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
                            <Typography fontWeight={700} className='title2' gutterBottom>
                                Categories
                            </Typography>
                            {categories && categories.length > 0 && (
                                <CategoriesList click={onCategorySelect} selectedIndex={selectedCategory} categories={categories} />
                            )}

                            {categories && categories.length == 0 && (
                                <CategorySkeleton />
                            )}
                        </Box>
                    </Grid>
                    <Grid item md={9} xs={12}>
                        <Box className={classes.col2}>
                            <Box my={2}>
                                {filteredTokens?.length > 0 && (
                                    <>
                                        <Typography variant="h6" gutterBottom>
                                            <strong>{getCategoryName()} Memberships</strong>
                                        </Typography>
                                        <Grid container spacing={4} >
                                            {filteredTokens?.map(token => {
                                                return (
                                                    <Grid item md={4} xs={12} key={token.id}>
                                                        <TokenCard token={token} click={onTokenSelect} />
                                                    </Grid>
                                                )
                                            })}

                                        </Grid>
                                    </>
                                )}
                                {(!filteredTokens || filteredTokens?.length == 0) && (
                                    <AppNoToken
                                        title="Business does not have any Memberships"
                                        body="The business has not yet minted any Memberships. Check back soon for an update."
                                    >
                                        {isBusiness() && (
                                            <Button className={'button'}
                                                component={Link} to={`/token/create`}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircleIcon />}
                                            >
                                                <Typography
                                                    fontWeight={700}
                                                    className={'button-label'}
                                                >
                                                    Create Membership
                                                </Typography>
                                            </Button>
                                        )}
                                    </AppNoToken>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                {/*<Box my={6}>
                    <Divider />
                </Box>

                <Grid container py={2} sx={{ mb: { xs: 6, md: 0 } }}>
                    <Grid item md={3} xs={12} sx={{ mb: { xs: 1, md: 0 } }}>
                        <Typography fontWeight={700} className='title2' color='#1E293B'>
                            FAQs
                        </Typography>
                    </Grid>
                    <Grid item md={9} xs={12}>
                        <Typography fontWeight={500} className='body1 wrapword' color='#475569'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ultrices odio eget vestibulum id sed. Integer amet sed eu, eu. Nec faucibus at odio nibh quam. Urna lectus orci accumsan eget laoreet. Hendrerit viverra turpis tempor ultrices. Sit egestas consectetur ac consequat. Sit volutpat quam feugiat sit mus fermentum eleifend massa.
                        </Typography>
                    </Grid>
                </Grid>*/}
            </AppContainer>
        </>
    )
}
